import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { useLanguage } from '../../contexts/LanguageContext';

const TermsConditionsNav = () => {
  const { t } = useLanguage();
  const [activeSection, setActiveSection] = useState('scope');

  const navItems = [
    { id: 'scope', label: t('terms.nav.scope') },
    { id: 'subject', label: t('terms.nav.subject') },
    { id: 'no-contract', label: t('terms.nav.noContract') },
    { id: 'platform-use', label: t('terms.nav.platformUse') },
    { id: 'user-obligations', label: t('terms.nav.userObligations') },
    { id: 'liability', label: t('terms.nav.liability') },
    { id: 'availability', label: t('terms.nav.availability') },
    { id: 'termination', label: t('terms.nav.termination') },
    { id: 'data-protection', label: t('terms.nav.dataProtection') },
    { id: 'final-provisions', label: t('terms.nav.finalProvisions') },
  ];

  // Track active section on scroll
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('.st-terms-section');
      const scrollPos = window.scrollY + 150;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');

        if (scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight) {
          setActiveSection(sectionId);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="st-terms-nav st-sticky">
      <h3 className="st-terms-nav-title">{t('terms.nav.title')}</h3>
      <ul className="st-terms-nav-list">
        {navItems.map((item) => (
          <li key={item.id}>
            <ScrollLink
              to={item.id}
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              className={activeSection === item.id ? 'active' : ''}
              onSetActive={() => setActiveSection(item.id)}
            >
              {item.label}
            </ScrollLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TermsConditionsNav;
